import request from './index'

export const carList = (listQuery, newParams) => {
  console.log(newParams);
  console.log(newParams != null ? newParams : listQuery.params);
  return request({
    url: '/car/list',
    method: 'post',
    data: {
      command_id: 25,
      entityId: listQuery.entityId,
      pageIndex: listQuery.pageIndex,
      pageSize: listQuery.pageSize,
      params: newParams != null ? newParams : listQuery.params,
      queryParams: listQuery.queryParams,
      categoryParams:listQuery.categoryParams,
      fuzzySearch: listQuery.fuzzySearch
    }
  })
}
// category search
export const carCategorySearch = (carCategoryQuery) => {
  return request({
    url: '/car/categorySearch',
    method: 'post',
    data: carCategoryQuery
  })
}

//根据运营单位id获取运营单位及其子单位的所有车辆信息
export const carListByEntityId = (listQuery,newParams) => {
  return request({
    url: '/car/list/'+listQuery.entityId,
    method: 'post',
    data: {
      command_id: 25,
      entityId: listQuery.entityId,
      pageIndex: listQuery.pageIndex,
      pageSize: listQuery.pageSize,
      params: newParams != null ? newParams : listQuery.params,
      fuzzySearch: listQuery.fuzzySearch
    }
  })
}

export const carListByParam = (listQuery, newParams) => {
  return request({
    url: '/car/doPage',
    method: 'post',
    data: {
      command_id: 25,
      isRobot: listQuery.isRobot,
	  carIdStr:listQuery.carIdStr,
      pageIndex: listQuery.pageIndex,
      pageSize: listQuery.pageSize,
      params: newParams != null ? newParams : listQuery.params,
      fuzzySearch: listQuery.fuzzySearch
    }
  })
}

export const carTypeList = listQuery => {
  return request({
    url: '/car/type/list',
    method: 'post',
    data: {
      command_id: 44,
	  entityId: listQuery.entityId,
      pageIndex: listQuery.pageIndex,
      pageSize: listQuery.pageSize,
      params: listQuery.params,
      fuzzySearch: listQuery.fuzzySearch
    }
  })
}


export const carEditFunction = formCarData => {
	return request({
		url:'/car/carEdit',
		method:'post',
		data:{
			carEditId: formCarData.carEditId,
			carEditName: formCarData.carEditName,
			carEditEntityId: formCarData.carEditEntityId,
			carEditModelId: formCarData.carEditModelId,
			carEditImg: formCarData.carEditImg,
			carEditWifiName:formCarData.carEditWifiName,
			carEditWifiPassword:formCarData.carEditwifiPassword,
			carEditWeight:formCarData.carEditWeight,
			carEditMaxWeight:formCarData.carEditMaxWeight,
			carEditNum4g:formCarData.carEditNum4g,
			carEditNumDiffer:formCarData.carEditNumDiffer,
			carEditActive4g:formCarData.carEditActive4g,
			carEditActiveDiffer:formCarData.carEditActiveDiffer,
			carEditExternalFlag:formCarData.carEditExternalFlag,
			carEditDeathDiffer:formCarData.carEditDeathDiffer,
			carEditExceptionCodeVersion:formCarData.carEditExceptionCodeVersion,
			carEditDailyWorkDistance:formCarData.carEditDailyWorkDistance
		}
	})
}


export const addCar = addCarForm => {
  return request({
		url:'/car/add',
		method:'post',
		data:{
		  carName: addCarForm.carName,
		  entityId: addCarForm.entityId,
		  isRobot: addCarForm.deviceType,
		  modelId:addCarForm.carModel,
		  img:addCarForm.img,
		  wifiName:addCarForm.wifiName,
		  wifiPassword:addCarForm.wifiPassword,
		}
	})
}


export const carDelete = carId => {
	return request({
		url:'/car/carDelete/'+carId,
		method:'delete',
	})
}

// 车辆在线时长
export const getTotaltime = carId => {
	return request({
		url:'/car/dataMonitor/getTotalTime/'+carId,
		method:'get',
	})
}

export const getEchartDataMonitor = (carId,currentTime) => {
	return request({
		url:'/car/dataMonitor/getEchartDataMonitor/'+carId+'/'+currentTime,
		method:'get',
	})
}

export const getOnlineByIdTime = dataMonitorReq => {
	return request({
		url:'/car/dataMonitor/getOnlineByIdTime',
		method:'post',
		data:{
			carId: dataMonitorReq.carId,
			dateList: JSON.stringify(dataMonitorReq.dateList),
		}
	})
}

// 车型在线时长获取
export const getCarTotalTime = () => {
	return request({
		url:'/car/dataMonitor/getCarTotalTime',
		method:'get',
	})
}

//实时监控列表
export const dataMonitorDataDetailList = listQuery => {
  return request({
    url: '/car/dataMonitor/dataMonitorDataDetail',
    method: 'post',
    data: {
      command_id: 63,
      carId: listQuery.carId,
	  currentTime:listQuery.currentTime,
      pageIndex: listQuery.pageIndex,
      pageSize: listQuery.pageSize,
    }
  })
}

//在线时长列表
export const getCarTotalTimeList = listQuery => {
  return request({
    url: '/car/dataMonitor/getCarTotalTimeList',
    method: 'post',
    data: {
      command_id: 63,
      carId: listQuery.carId,
      pageIndex: listQuery.pageIndex,
      pageSize: listQuery.pageSize,
    }
  })
}

export const getCarById = carId => {
	return request({
		url:'/car/dataMonitor/getCarById/'+carId,
		method:'get',
	})
}

export const download = (carNum,equipmentType) => {
  return request({
    url: '/car/download/'+carNum+'/'+equipmentType,
    method: 'post',
	  responseType: 'blob'
  })
}

export const carTypeSave = carTypeForm => {
  return request({
    url: '/car/type/carTypeSave',
    method: 'post',
    data: {
      id: carTypeForm.addmodelId,
      name: carTypeForm.addmodelName,
	  typeId:carTypeForm.addtypeId,
      length: carTypeForm.addtypeLength,
      width: carTypeForm.addtypeWidth,
      height: carTypeForm.addtypeHeight,
      weight: carTypeForm.addtypeWeight,
    }
  })
}

export const carTypeDelete = typeId => {
  return request({
    url: '/car/type/carTypeDelete/'+typeId,
    method: 'delete',
  })
}

export const getRecord = carId => {
  return request({
    url: '/car/voice/getRecord/'+carId,
    method: 'get',
  })
}

//获取所有型号
export const getCarTypes = entityId =>{
  return request({
    url: '/car/type/types',
    method: 'post',
    data:{
        entityId:entityId
    }
  })
}

//获取所有类型
export const getAllCarTypes = ()=>{
  return request({
    url: '/car/type/alltypes',
    method: 'post',
	data:{}
  })
}

export const getNotRepeatingCarTypes = entityId =>{
  return request({
    url: '/car/type/getNotRepeatingTypes',
    method: 'post',
    data:{
      entityId:entityId
    }
  })
}


export const getTypesByCarTypeName = (entityId,carTypeName) =>{
  return request({
    url: '/car/type/getTypesByCarTypeName',
    method: 'post',
    data:{
      entityId:entityId,
      carTypeName:carTypeName
    }
  })
}

//获取车辆所属用户
export const getCarUsers = (carId) =>{
	return request({
		 url: '/car/getCarUserByIdTra/'+carId,
		 method: 'post',
		 data: {
		 	carId :carId
		 }
	})
}

//车辆添加用户
export const insertCarUserTra = (formData) =>{
	return request({
	  url: '/car/addCarUserTra',
	  method: 'post',
	  data: {
		  id : formData.editCarId ,
		  users:formData.editUserName,
	  }
	})
}

//车辆删除用户
export const deleteCarUserTra = (editCarId,editUserName) =>{
	return request({
	  url: '/car/deleteCarUserTra',
	  method: 'post',
	  data: {
		  id : editCarId ,
		  users:editUserName,
	  }
	})
}

//获取轨迹
export const getCarTrackFromLog= (carId,currentTime) => {
	return request({
		url:'/car/dataMonitor/getCarTrackFromLog/'+carId+'/'+currentTime,
		method:'get',
	})
}


//获取车辆抓拍照片
export const getCarPhotoFromFtp = (carId,listQuery) => {
  return request({
    url: '/car/dataMonitor/getCarPhotographByFtp/',
    method: 'post',
    data: {
      pageIndex: listQuery.pageIndex,
      pageSize: listQuery.pageSize,
	  carId:carId,
	  currentTime:listQuery.currentTime
    }
  })
}

//预览你车辆抓拍照片
export const photographPreview = (carId,filePath,fileName)=>{
    return request({
        url: '/car/dataMonitor/photographPreview',
        method: 'post',
        data: {
          carId:carId,
          mapPackNum:filePath,
          fileName:fileName
        },
        responseType: 'blob'
    })
}

export const getCarOperateData = (carId,listQuery) => {
	return request({
	  url: '/car/dataMonitor/getCarOperateData/',
	  method: 'post',
	  data: {
			carId:carId,
			startTime:listQuery.startTime,
			endTime:listQuery.endTime
	  }
	})
}

export const getCarAutoOperateData = (carId,listQuery) => {
	return request({
	  url: '/car/dataMonitor/getCarAutoOperateData/',
	  method: 'post',
	  data: {
			carId:carId,
			startTime:listQuery.startTime,
			endTime:listQuery.endTime,
			pageIndex:listQuery.pageIndex,
			pageSize:listQuery.pageSize
	  }
	})
}

export const dataCsvExport= (carId,startTime,endTime) => {
	return request({
		url:'/car/dataMonitor/exceldown/'+carId+'/'+startTime+'/'+endTime,
		method:'get',
		responseType: 'blob'
	})
}

export const dataJsonExport= (carId,currentTime) => {
	return request({
		url:'/car/dataMonitor/jsondown/'+carId+'/'+currentTime,
		method:'get',
		responseType: 'blob'
	})
}

export const dataExport= (carId,currentTime) => {
	return request({
		url:'/car/dataMonitor/monitorexceldown/'+carId+'/'+currentTime,
		method:'get',
		responseType: 'blob'
	})
}

export const setCarPartsUsing = formCarData => {
	return request({
		url:'/car/setCarPartsUsing',
		method:'post',
		data:formCarData
	})
}

//获取APP车辆信息
// export const listAppCar = (listQuery) => {
//   return request({
//     url: '/car/listAppCar',
//     method: 'post',
//     data: {
// 	  loginAdmin:listQuery.loginAdmin,
//       pageIndex: listQuery.pageIndex,
//       pageSize: listQuery.pageSize,
//       params: listQuery.params,
//       fuzzySearch: listQuery.fuzzySearch
//     }
//   })
// }

//更新APP车辆信息
// export const updateAppCar = formData => {
//   return request({
//     url: '/car/updateAppCar',
//     method: 'post',
//     data: {
// 	  id : formData.id ,
// 	  devicePic:formData.devicePic,
//       wifiName: formData.wifiName,
//       wifiPassword: formData.wifiPassword,
//     }
//   })
// }

//添加车辆-用户关联
// export const insertAppCarUser = formData => {
//   return request({
//     url: '/car/addUserAppCar',
//     method: 'post',
//     data: {
// 	  id : formData.id ,
// 	  userName:formData.userName,
//     }
//   })
// }